<template>
  <u-intersect :once="true" @enter="initCounter">
    <figure class="facts-counter">
      <div class="facts-counter__inner">
        <i-count-up
          v-if="isActive && !noAnimation"
          aria-hidden="true"
          class="facts-counter__number"
          :delay="config.delay"
          :end-val="config.endVal"
          :options="config.options"
        ></i-count-up>
        <span
          v-if="!isActive && !noAnimation"
          aria-hidden="true"
          class="facts-counter__number"
          >0{{ decimalLocale }}{{ placeholderDecimals }}</span
        >
        <span
          :class="{ 'a-visually-hidden': !noAnimation }"
          class="facts-counter__number"
          >{{ localizedNumber }}</span
        >
        <span class="facts-counter__suffix">
          {{ suffix }}
        </span>
      </div>
      <div class="facts-counter__text">
        <slot />
      </div>
    </figure>
  </u-intersect>
</template>

<script>
import ICountUp from 'vue-countup-v2';

export default {
  components: {
    ICountUp,
  },
  props: {
    number: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 2000,
    },
    delay: {
      type: Number,
      default: 300,
    },
    suffix: {
      type: String,
    },
    locale: {
      type: String,
      default: 'de',
    },
  },
  data: function () {
    return {
      isActive: false,
    };
  },
  computed: {
    localizedNumber() {
      return this.number
        .toString()
        .replaceAll('.', '#')
        .replaceAll(',', '~')
        .replaceAll('#', this.decimalLocale)
        .replaceAll('~', this.separatorLocale);
    },
    separatorLocale() {
      if (this.locale === 'en') return ',';
      return '.';
    },
    decimalLocale() {
      if (this.locale === 'en') return '.';
      return ',';
    },
    decimalCount() {
      const strNumber = this.number.toString();
      const splitNumber = strNumber.split('.');
      if (splitNumber.length <= 1) return 0;
      return splitNumber[splitNumber.length - 1].length;
    },
    config() {
      return {
        delay: this.delay,
        endVal: this.number,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: this.separatorLocale,
          decimal: this.decimalLocale,
          prefix: '',
          suffix: '',
          decimalPlaces: this.decimalCount,
          duration: this.duration / 1000,
        },
      };
    },
    noAnimation() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        return true;
      return false;
    },
    placeholderDecimals() {
      let str = '';
      for (let i = 0; i < this.decimalCount; i++) {
        str += '0';
      }
      return str;
    },
  },
  methods: {
    initCounter() {
      this.isActive = true;
    },
  },
};
</script>
